import { fetchQuery, graphql, Environment } from 'relay-runtime';
import { filterNulls } from 'dibs-ts-utils/exports/filterNulls';

import { SocialNetworkName } from '../types';
import { getSocialNetworksQuery } from './__generated__/getSocialNetworksQuery.graphql';

const query = graphql`
    query getSocialNetworksQuery {
        viewer {
            socialNetworks {
                name
                parameters {
                    clientId
                }
            }
        }
    }
`;

type Viewer = NonNullable<getSocialNetworksQuery['response']['viewer']>;
type SocialNetworks = NonNullable<Viewer['socialNetworks']>;

function getSocialNetworks(relayEnvironment: Environment): Promise<SocialNetworks> {
    return fetchQuery<getSocialNetworksQuery>(relayEnvironment, query, {})
        .then(response => {
            return response?.viewer?.socialNetworks || [];
        })
        .catch(() => []);
}

const getSocialNetwork = (function() {
    let socialNetworkPromise: Promise<SocialNetworks> | null;

    return {
        byName: function(networkName: SocialNetworkName, relayEnvironment: Environment) {
            if (!socialNetworkPromise) {
                socialNetworkPromise = getSocialNetworks(relayEnvironment);
            }
            return socialNetworkPromise.then(socialNetworks =>
                socialNetworks.filter(filterNulls).find(({ name }) => name === networkName)
            );
        },
    };
})();

export { getSocialNetwork };
